module.exports = __webpack_public_path__ + "img/dlt_kind_9.02dadc6a.png";